import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/theoportlock',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.linkedin.com/in/theo-portlock-234180227/',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://facebook.com/theoportlock',
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: 'https://www.instagram.com/theoportlock',
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: 'https://twitter.com/theoportlock',
    label: 'Twitter',
    icon: faTwitter,
  },
  {
    link: 'https://scholar.google.com/citations?hl=en&user=CgEANTAAAAAJ',
    label: 'Scholar',
    icon: faEnvelope,
  },
];

export default data;
